const formatMessageType = (item) => {
  if (item.data.channel) {
    switch (item.data.channel) {
      case 'push_notification':
        return 'Push Notification';
      case 'email':
        return 'Sent email';
      case 'sms':
        return 'Sent SMS';
      default:
        return item.data.channel;
    }
  } else {
    switch (item.type) {
      case 'sms_reply_log_entry':
        return 'SMS reply';
      case 'email_log_entry':
        return 'Sent email';
    }
  }
};

export default formatMessageType;
